import Env from '../base/env'
import gsap from 'gsap'
import { lerp } from '../vendor/utils'

export default class BtnShadow
{
  constructor(btn)
  {
    this.DOM = {}
    this.DOM.btn = btn
    this.VARS = {}

    this.coords = this.DOM.btn.getBoundingClientRect()
    this.shadowMax = this.coords.height;
    this.shadowMin = this.shadowMax * -1;
    this.shadowMidPoints = [
      this.coords.x + this.coords.width / 2,
      this.coords.y + this.coords.height / 2
    ];

    this.raf = false;
    this.events()
  }

  events()
  {
    window.addEventListener('mousemove',(e)=>{
      this.shadowX = Math.min(this.shadowMax, Math.max(this.shadowMin, this.shadowMidPoints[0] - e.pageX));
      this.shadowY = Math.min(this.shadowMax, Math.max(this.shadowMin, this.shadowMidPoints[1] - e.pageY));
    })

    this.watcher()
  }


  watcher()
  {
    this.raf = requestAnimationFrame(()=>{

      this.lastShadowX = lerp(this.lastShadowX || this.shadowX, this.shadowX, .05);
      this.lastShadowY = lerp(this.lastShadowY || this.shadowY, this.shadowY, .05);
      gsap.set(this.DOM.btn, { boxShadow: `${this.lastShadowX/3}px ${this.lastShadowY/2.5}px 15px rgba(0, 0, 0, 0.0666667)` })

      this.watcher()
    })
  }
}
